import styled from 'styled-components';
import { Link } from "react-router-dom";

export const ContainerNull = styled.div`
    display: flex;
    flex-direction: column;
    align-items:center;
    justify-content: center;
    border-bottom-left-radius: 9px;
    border-bottom-right-radius: 9px;
    height: 250px;
    border: 1px solid black;
    background-color: #FFF;
    margin-bottom: 10px;
    padding: 8px;
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #EFEFEC;
    height: 100%;

    .area-header-campanhas{
        display: flex;
    }

    .disabled{
        background-color: #CCC;
        color: #FFF;
        cursor: not-allowed;
    }

    .close{
        position: absolute;
        right: -10px;
        top: -10px;
        cursor: pointer;
        background-color: #E74C3C;
        width: 30px;
        height: 30px;
        border-radius: 20px;
    }


`;

export const ContainerProdutos = styled.div`
    margin-left: 230px;
    margin-right: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
    border-radius: 9px;
    background-color: #FFF;
    @media(max-width:700px){
        margin-left: 5px;
        margin-right: 5px;
        margin-top: 10px;
        margin-bottom: 10px;
        height: 100%;
        border-radius: 9px;
        background-color: #FFF;
    }
`;

export const Titulo = styled.h1`
    background-color: #DC4405;
    border-top-right-radius: 9px;
    border-top-left-radius: 9px;
    color: #FFF;
    padding: 10px;
`;

export const AreaHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

export const AreaPesquisa = styled.div`
    display: flex;
    width: 250px;
    margin: 15px;
    padding: 2px;
    border-radius: 9px;
    border:solid #EFEFEC 2px;
    background-color: #FFF;
    @media screen and (max-width: 700px){
        margin-right: 0;
    }
`;

export const ButtonNovo = styled(Link)`
    padding: 10px;
    margin: 15px;
    color: #F28F1A;
    font-weight: bold;
    border: solid #EFEFEC 1px;
    background-color:#FFF;
    border-radius: 9px;

    &:hover{
        background-color: #DC4405;
        color: #FFF;
    }
`;

//Tabela de itens

export const ContainerTabela = styled.div`
    margin: 15px;
    display: flex;
    justify-content: center;
`;

export const Tabela = styled.table`
&caption{
    font-size: 1.5em;
    margin: .5em 0 .75em;
}
`;

export const Thead = styled.thead`
    display: table;
    width: 100%;
    table-layout: fixed;
    @media(max-width:700px){
        border: none;
        clip:rect(0 0 0 0);
        height: 1px;
        margin: -1px;
        overflow: hidden;
        padding: 0;
        position: absolute;
        width: 1px;
    }
`;

export const TR = styled.tr`
    display: table;
    width: 100%;
    table-layout: fixed;
    padding: 20px;
    text-align: center;
    @media(max-width:700px){
        border-bottom: 3px solid #DDD;
        display: block;
        margin-bottom: .65em;
    }
`;

export const TH = styled.th`
    font-size: .85em;
    letter-spacing: .1em;
    text-transform: uppercase;
    background-color: #DC4405;
    color: #FFF;
    padding:10px;
    text-align: center;
`;

export const Tbody = styled.tbody`
    display: block;
    width: 100%;
`;

export const TD = styled.td`
    @media(max-width:700px){
        border-bottom: 1px solid #DDD;
        display: block;
        font-size: .8em;
        text-align: right;
        &::before{
            content: attr(data-label);
            float: left;
            font-weight: bold;
            text-transform: uppercase;
        }
    }
`;

export const SpanStatus = styled.span`
    padding: 3px;
    border-radius: 3px;
    color: #FFF;
`;

export const ButtonEditar = styled(Link)`
    border: 0;
    padding: 5px;
    align-items: center;
    background-color: #00A8FF;
    color: #FFF;
    font-weight: bold;
    border-radius: 3px ;
    &:hover{
        background-color: #FFF;
        color: #00A8FF;
    }
`;

export const ButtonDeletar = styled.button`
    border: 0;
    font-weight: bold;
    padding: 5px 15px;
    align-items: center;
    background-color:rgb(248, 39, 39);
    color: #FFF;
    border-radius: 10px ;
    height: 45px;
    display: flex;
    margin-right: 30px;
`;

export const ModalDeletarCampanhas = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;

    .area-modal{
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #FFF;
        border-radius: 10px;
        padding: 10px;
        width: 400px;
    }
    
    h1{
        font-size: 20px;
        font-weight: bold;
        color: #000;
    }

    p{
        font-size: 16px;
        color: #000;
        margin: 20px 0px;
        text-align: center;
    }

    .area-buttons{
        display: flex;
        justify-content: center;
        width: 100%;
    }

    button{
        padding: 10px 20px;
        background-color:rgba(0, 170, 255, 0.76);
        color: #FFF;
        font-weight: bold;
        border-radius: 10px;
        border: 0;
    }

    .aprovar{
        background-color:#2ECC71;
    }

    .rejeitar{
        background-color:#E74C3C;
    }
    
    button:hover{
        background-color: #FFF;
        color:rgb(0, 0, 0);
    }
`;